import { Check, Minus, X } from "lucide-react";
import type { SettingToggle } from "@produce/shared";

/**
 * A user's on/off settings.
 *
 * Three states, not two: a `null` means the user never touched the setting, so
 * it is running on the app's default. Showing that as "off" would send support
 * chasing a switch the user never flipped.
 */
export default function SwitchGrid({ toggles }: { toggles: SettingToggle[] }) {
  if (toggles.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        No settings stored — this user has never changed a setting.
      </p>
    );
  }

  return (
    <ul className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
      {toggles.map((toggle) => (
        <li key={toggle.label} className="flex items-center gap-2 text-sm">
          {toggle.enabled === true && <Check className="h-4 w-4 text-emerald-500" />}
          {toggle.enabled === false && <X className="h-4 w-4 text-destructive" />}
          {toggle.enabled === null && <Minus className="h-4 w-4 text-muted-foreground" />}
          <span className={toggle.enabled === false ? "font-medium" : ""}>{toggle.label}</span>
          {toggle.enabled === null && (
            <span className="text-xs text-muted-foreground">(default)</span>
          )}
        </li>
      ))}
    </ul>
  );
}
